<template>
    <div class="upload-single-image d-flex flex-column h-100">
        <div class="row" v-if="label">
            <div class="col">
                <h6 class="font-weight-normal">{{label}}</h6>
                <hr class="mt-2" />
            </div>
        </div>
        <div class="row h-100">
            <div class="col-12">
                <div class="h-100">
                    <UploadMultipleImage
                        :disabled="disabled"
                        v-model="images"
                        :maxImage="1"
                        :multiple="false"
                        :noOverlay="true"
                        :name="name"
                        :showImageLimitMessage="false"
                        :imageClass="imageClass"
                        :pathProperty="pathProperty"
                        :typeProperty="typeProperty"
                        :filenameProperty="filenameProperty"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {isAbsoluteURL, isString} from '@config/utils';

export default {
    name: 'UploadSingleImage',
    components: {
        UploadMultipleImage: () => import(/* webpackChunkName: "upload-multiple-image" */ '@/components/form/UploadMultipleImage.vue'),
    },
    props: {
        value: {
            type: [Object, String, File],
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            require: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        imageClass: {
            type: String,
            default: 'background-cover'
        },
        pathProperty: {
            type: String,
            default: 'path'
        },
        typeProperty: {
            type: String,
            default: 'type'
        },
        filenameProperty: {
            type: String,
            default: 'name'
        },
    },
    data() {
        return {
            images: [],
        }
    },
    methods: {
        getFormatUrlAPI(path) {
            return this.$root.$helper.global.formatUrlAPI(path);
        },
        changeValue(value) {
            if(isString(value)) {
                this.images = value ? [{path: isAbsoluteURL(value) ? value : this.getFormatUrlAPI(value)}] : [];
            }else if(value instanceof File){
                const reader = new FileReader();
                reader.onloadend = (e) => {
                    let dataURI = e.target.result;

                    let item = {file: value};
                    if(this.typeProperty) {
                        item[this.typeProperty] = value.type;
                    }
                    if(this.filenameProperty) {
                        item[this.filenameProperty] = value.name;
                    }
                    if(this.pathProperty) {
                        item[this.pathProperty] = dataURI;
                    }
                    this.images = [item];
                };
                reader.readAsDataURL(value);
            }
        }
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newValue, oldValue) {
                this.changeValue(newValue);
            },
        },
        images: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue.length ? newValue[0] : null);
            },
        },
    },
}
</script>